module.exports = __webpack_public_path__ + "2674fb1cff8536d1588b00ef019daedc.png";